import { useHookstate } from '@hookstate/core'
import React, { useEffect } from 'react'
import CrudIndex from '~/components/CrudIndex'
import Layout from '~/components/Layout'
import { useLang } from '~/hooks/useLang'

export default function Index() {
  const { translate } = useLang()

  const forceRefresh = useHookstate(false)
  const name = useHookstate<string | null>(null)

  useEffect(() => {
    document.title = translate('Administration - Dispatch System')
  }, [])

  const weaponBrandFilter = [
    {
      name: 'name',
      type: 'name',
      placeholder: 'Name',
      variable: name,
    },
  ]

  return (
    <Layout marginLayout={true}>
      <CrudIndex
        model="weapon-brand"
        title="Weapon Brand"
        disableColumnsFilters
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
        forceRefresh={forceRefresh.get()}
        filters={weaponBrandFilter}
        clearFilters={() => {
          name.set(null)
          forceRefresh.set(!forceRefresh.get())
        }}
        canView={true}
        viewTitle="Weapon Brand"
        showInViewMore={['name', 'created_at']}
      />
    </Layout>
  )
}
